<template>
  <div class="container-market-select-btn" :class="{ 'container-market-select-btn--extended': isExtendedView }" v-if="isSmallScreen && allHeaderMarkets.length > 0">
    <button class="platform-button" @click="showModal = true">
      <span class="selected-market-name">{{ currentMobileMarketName }}</span>
      <svg style="vertical-align:middle" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    </button>

    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="bottom-sheet" ref="sheet">
        <div class="drag-bar"></div>
        <ul class="sheet-list">
          <li
                  v-for="(market, idx) in allHeaderMarkets"
                  :key="market.key || market.marketId || idx"
                  :class="{active: idx === selectedMarketIndex}"
                  @click="handleSelect(idx)"
          >
            {{ market.marketAlias || market.marketName }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MarketSelector',
    computed: {
      ...mapGetters({ getEventViewMode: 'ui/getEventViewMode' }),
      isExtendedView() {
        return this.isSmallScreen && this.getEventViewMode === 'extended';
      },
    },
    props: {
      isSmallScreen: {
        type: Boolean,
        default: false
      },
      allHeaderMarkets: {
        type: Array,
        default: () => []
      },
      selectedMarketIndex: {
        type: Number,
        default: 0
      },
      currentMobileMarketName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        showModal: false
      }
    },
    methods: {
      closeModal() {
        this.showModal = false;
      },
      handleSelect(idx) {
        this.$emit('select', idx);
        this.closeModal();
      }
    }
  }
</script>

<style scoped>
  .market-select-btn {
    color: var(--text-platform);
    font-size: var(--font-size-3xl);
    font-weight: 500;
    padding: 0 8px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--bg-panel);
    border: 1px solid var(--border-color);
    gap: 6px;
    min-height: 38px;
    touch-action: manipulation;
    transition: background-color 0.2s;
  }
  .market-select-btn:active { opacity: 0.75; }

  .modal-overlay {
    position: fixed;
    inset: 0; /* Nota: inset funziona nei browser moderni. Se devi supportare browser vecchi usa top:0; left:0; right:0; bottom:0; */
    z-index: 9999;
    background: var(--modal-overlay);
    backdrop-filter: blur(9px);
    display: flex;
    align-items: flex-end;
  }

  .bottom-sheet {
    width: 100vw;
    min-height: 30vh;
    background: var(--bg-panel);
    border-radius: 20px 20px 0 0;
    overflow: hidden;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, .22);
    animation: sheetIn .30s cubic-bezier(.22, .68, .55, 1.25);
    padding-bottom: 80px;
  }

  .drag-bar {
    width: 48px;
    height: 5px;
    background: var(--text-op-50-platform);
    opacity: 0.5;
    border-radius: 3px;
    margin: 10px auto 8px;
  }

  .sheet-list {
    list-style: none;
    padding: 0 0 12px 0;
    margin: 0;
    padding-left: 0 !important;
  }

  .sheet-list li {
    color: var(--text-platform);
    padding: 14px 18px;
    font-size: var(--font-size-4xl);
    border-bottom: 1px solid var(--border-color);
    cursor: pointer;
    transition: background .13s;
    min-height: 44px;
    display: flex;
    align-items: center;
    touch-action: manipulation;
  }
  .sheet-list li:active { background: var(--bg-cell); }

  .sheet-list li.active,
  .sheet-list li:hover {
    color: var(--color-primary);
    font-weight: bolder;
  }
  .container-market-select-btn{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .container-market-select-btn--extended {
    width: 100%;
  }
  .container-market-select-btn--extended .platform-button {
    width: 100%;
  }
  svg{
    fill: currentColor;
  }

  @keyframes sheetIn {
    from {
      transform: translateY(110%);
    }
    to {
      transform: translateY(0);
    }
  }
</style>